import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllAdminsLoadAction } from '../../domains/allAdmins/loadActions.types';

import { Admins } from './types';

const initialState: Admins = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Admins, AllAdminsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_ADMINS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.admins);
    default:
      return state;
  }
};

export default reducer;
